<ng-container *ngIf="isLoading; else pageContent">
  <div class="app-spinner">
    <mat-spinner diameter="50"></mat-spinner>
  </div>
</ng-container>

<ng-template #pageContent>
  <ng-container *ngIf="policyBindingData; else showMessage">
    <div class="assessment-page">
      <div class="page-header">
        <div>
          <button
            class="back-btn"
            routerLink="/proctoring-dashboard/proto-assessment"
          >
            <i class="bi bi-arrow-left"></i>
            Back
          </button>

          <h1 *ngIf="policyBindingData">
            {{ policyBindingData.evaluationTitle || "Assessment" }}
          </h1>

          <p *ngIf="policyBindingData">
            {{ policyBindingData.proctoringEvaluationOnId || "-" }} ·
            {{ policyBindingData.ruleSetName || "-" }}
          </p>
        </div>

        <span class="status-badge" *ngIf="policyBindingData">
          {{ policyBindingData.isEnabled ? "Enabled" : "Disabled" }}
        </span>
      </div>

      <div class="stats-grid" *ngIf="policyBindingData">
        <div class="stat-card">
          <div class="card-label">
            <i class="bi bi-shield-check"></i>
            RULESET
          </div>

          <h2>{{ policyBindingData.ruleSetName || "-" }}</h2>
        </div>

        <div class="stat-card">
          <div class="card-label">
            <i class="bi bi-clock"></i>
            DURATION
          </div>

          <h2>60 min</h2>
        </div>

        <div class="stat-card">
          <div class="card-label">
            <i class="bi bi-people"></i>
            CANDIDATES
          </div>

          <h2>{{ policyBindingData.sessionCount || "0" }}</h2>
        </div>

        <div class="stat-card">
          <div class="card-label">
            <i class="bi bi-speedometer2"></i>
            AVG. INTEGRITY
          </div>

          <h2 class="green">92%</h2>
        </div>
      </div>

      <div class="overview-card" *ngIf="policyBindingData">
        <div class="tabs">
          <button
            [class.active]="activeTab === 'overview'"
            (click)="activeTab = 'overview'"
          >
            Overview
          </button>

          <button
            [class.active]="activeTab === 'candidates'"
            (click)="activeTab = 'candidates'"
          >
            Candidates
          </button>

          <button
            [class.active]="activeTab === 'sessions'"
            (click)="activeTab = 'sessions'"
          >
            Sessions
          </button>
        </div>

        <div *ngIf="activeTab === 'overview'">
          <div class="summary-grid">
            <div class="summary-card">
              <div class="summary-title">Session summary</div>

              <div class="summary-row">
                <span>Completed sessions</span>
                <strong>224</strong>
              </div>

              <div class="summary-row">
                <span>Proctored sessions</span>
                <strong>224</strong>
              </div>

              <div class="summary-row">
                <span>Average integrity</span>
                <strong>92%</strong>
              </div>

              <div class="summary-row">
                <span>Created</span>
                <strong>{{
                  policyBindingData.createdAt | date: "yyyy-MM-dd"
                }}</strong>
              </div>
            </div>

            <div class="summary-card">
              <div class="summary-title warning">
                <i class="bi bi-exclamation-triangle"></i>
                Violation summary
              </div>

              <div class="summary-row">
                <span>Total violations</span>
                <strong>342</strong>
              </div>

              <div class="summary-row">
                <span>Critical</span>
                <strong class="red">14</strong>
              </div>

              <div class="summary-row">
                <span>High</span>
                <strong>58</strong>
              </div>

              <div class="summary-row">
                <span>Medium</span>
                <strong>121</strong>
              </div>

              <div class="summary-row">
                <span>Low</span>
                <strong class="blue">149</strong>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="activeTab === 'candidates'">
          <app-proctoring-candidates></app-proctoring-candidates>
        </div>

        <div *ngIf="activeTab === 'sessions'">
          <div class="coming-soon">
            <i class="bi bi-camera-video"></i>

            <h3>Sessions</h3>

            <p>Session list will appear here.</p>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-template #showMessage>
    <div class="assessment-page">
      <div class="page-header">
        <div>
          <button
            class="back-btn"
            routerLink="/proctoring-dashboard/proto-assessment"
          >
            <i class="bi bi-arrow-left"></i>
            Back
          </button>
        </div>
      </div>
    </div>
    <p class="text-center">no assessment available</p>
  </ng-template>
</ng-template>
